// Two-layer San Antonio skyline. The layers take different `shift` amounts so
// scrolling parallaxes the near buildings past the far ones.
export default function Skyline({ tone = "#0F0F0F", far = 0.05, near = 0.09, shift = 0 }) {
  return (
    <svg viewBox="0 0 1200 300" preserveAspectRatio="xMidYMax slice" aria-hidden="true">
      <g fill={tone} opacity={far} style={{ transform: `translateY(${shift * 0.5}px)` }}>
        <rect x="40" y="150" width="46" height="150" />
        <rect x="120" y="120" width="60" height="180" />
        <rect x="250" y="160" width="90" height="140" />
        <rect x="420" y="110" width="50" height="190" />
        <rect x="560" y="150" width="70" height="150" />
        <rect x="760" y="130" width="55" height="170" />
        <rect x="900" y="160" width="80" height="140" />
        <rect x="1060" y="140" width="60" height="160" />
      </g>
      <g fill={tone} opacity={near} style={{ transform: `translateY(${shift}px)` }}>
        <rect x="70" y="140" width="70" height="160" />
        <rect x="82" y="115" width="46" height="30" />
        <rect x="94" y="95" width="22" height="24" />
        <polygon points="105,60 94,96 116,96" />
        <rect x="103" y="48" width="4" height="16" />
        <rect x="190" y="170" width="100" height="130" />
        <rect x="215" y="145" width="50" height="30" />
        <rect x="330" y="105" width="55" height="195" />
        <rect x="385" y="135" width="45" height="165" />
        <rect x="480" y="120" width="70" height="180" />
        <polygon points="480,120 550,120 535,88 495,88" />
        <rect x="513" y="74" width="4" height="18" />
        <rect x="590" y="185" width="70" height="115" />
        <rect x="680" y="150" width="60" height="150" />
        <rect x="700" y="128" width="20" height="26" />
        {/* Tower of the Americas */}
        <rect x="836" y="120" width="14" height="180" />
        <ellipse cx="843" cy="105" rx="42" ry="18" />
        <ellipse cx="843" cy="93" rx="30" ry="10" />
        <rect x="841" y="42" width="4" height="46" />
        <rect x="940" y="170" width="85" height="130" />
        <rect x="1050" y="145" width="60" height="155" />
        <rect x="1130" y="180" width="50" height="120" />
      </g>
    </svg>
  );
}
